import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import API_BASE_URL from "../../config/apiConfig";

export const fetchInsights = createAsyncThunk("insights/fetchAll", async (_, { rejectWithValue }) => {
    try {
        const { data } = await axios.get(`/api/insights`);
        // const { data } = await axios.get(`${API_BASE_URL}/insights`);
        return data.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

export const fetchInsightsByCategory = createAsyncThunk(
    "insights/fetchByCategory",
    async (categoryId, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`/api/get_insights_by_category/${categoryId}`);
            // const { data } = await axios.get(`${API_BASE_URL}/get_insights_by_category/${categoryId}`);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchInsightById = createAsyncThunk(
    "insights/fetchById",
    async (id, { rejectWithValue }) => {
        try {
            const { data } = await axios.get(`/api/insight/${id}`);
            // const { data } = await axios.get(`${API_BASE_URL}/insight/${id}`);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const createInsight = createAsyncThunk(
    "insights/create",
    async (insightData, { rejectWithValue, getState }) => {
        try {
            const {
                userLogin: { userInfo },
            } = getState();

            const config = {
                headers: {
                    Authorization: `Bearer ${userInfo.token}`, // do NOT set Content-Type manually
                },
            };

            const { data } = await axios.post(
                `/api/insight`,
                insightData, // FormData
                config
            );
            // const { data } = await axios.post(
            //     `${API_BASE_URL}/insight`,
            //     insightData, // FormData
            //     config
            // );

            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


export const updateInsight = createAsyncThunk(
    "insights/update",
    async ({ id, insightData }, { rejectWithValue, getState }) => {
        try {
            const {
                userLogin: { userInfo },
            } = getState();

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userInfo.token}`,
                },
            };

            const { data } = await axios.put(`/api/insight/${id}`, insightData, config);
            // const { data } = await axios.put(`${API_BASE_URL}/insight/${id}`, insightData, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const deleteInsight = createAsyncThunk(
    "insights/delete",
    async (id, { rejectWithValue, getState }) => {
        try {
            const {
                userLogin: { userInfo },
            } = getState();
            const config = {
                headers: {
                    Authorization: `Bearer ${userInfo.token}`,
                },
            };

            await axios.delete(`/api/insight/${id}`, config);
            // await axios.delete(`${API_BASE_URL}/insight/${id}`, config);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);